import React, { useState } from 'react';
import { Box, Container, Text, VStack } from '@chakra-ui/react';
import { pageFadeIn } from '../../../utils/animations';
import NavBar from '../../../Components/Navbar/NavBar';
import Sales from "./SalesKR";
import Reports from "./ReportsKR";
import About from './AboutKR';
import kr_logo from '../../../Assets/kr_logo.png';

function KR() {
    const [selectedOption, setSelectedOption] = useState('Sales');
    
    const handleTabClick = (tab) => {
        setSelectedOption(tab);
    };

    const renderContent = () => {
        switch (selectedOption) {
            case 'Sales':
                return <Sales content="Sales KR" color="yellow" />;
            case 'Reports':
                return <Reports content="Reports KR" />;
            case 'About':
                return <About content="About KR" />;
            default:
                return <Sales content="Sales KR" color="yellow" />;
        }
    };

    return (
        <Box h="100vh" bg="gray.50" overflow="hidden">
            <NavBar 
                tabIndicatorColor="yellow.500" 
                logo={kr_logo} 
                onTabClick={handleTabClick} 
            />
            
            <Box
                w="100%"
                h="calc(100vh - 60px)"
                overflow="hidden"
                bgColor="white"
                bgImage={`linear-gradient(rgba(255,255,255,0.88), rgba(255,255,255,0.88)), url(${kr_logo})`}
                bgRepeat="no-repeat"
                bgSize="40% auto"
                bgPosition="right -80px"
                sx={{ animation: `${pageFadeIn} 0.55s ease both` }}
            >
                {renderContent()}
            </Box>
        </Box>
    );
}

export default KR;
